import React, {useState} from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { HeadlinePage } from 'components/common';
import { useTranslation } from 'react-i18next';
import { changePasswordPolicies } from 'helpers';
import { useStyle } from './styles';
import { Input } from 'components/layout';
import {
  Paper,
  Grid,
  CircularProgress,
  Backdrop,
  Button,
  IconButton,
  InputAdornment
} from '@mui/material';
import {useUser} from "components/hooks";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


export default function ChangePasswordDumb({ handleOnSubmit }) {
  const { isLoaded} = useUser();
  const [showPassword, setShowPassword] = useState(false);
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    }
  });
  const { handleSubmit, control, setError } = methods;

  const fields = [
    { policy: changePasswordPolicies.oldPassword },
    { policy: changePasswordPolicies.newPassword },
    { policy: changePasswordPolicies.confirmPassword },
  ];

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFormSubmit = (data) => {
    if (data && data.newPassword !== data.confirmPassword) {
      setError(changePasswordPolicies.confirmPassword.name, {message: t('changePassword.form.error.equalPassword')})
      return;
    }
    handleOnSubmit(data);
  }

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.password}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={'changePassword.headline'}/>
      <FormProvider { ...methods }>
        <Paper className={classes.paperTemplate}>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <Grid container spacing={2}>
              {fields.map((field) => (
                <Grid item xs={12} sm={12} md={12} lg={12} key={field.policy.id}>
                  <Input
                    {...field.policy}
                    control={control}
                    sx={{ width: '100%' }}
                    InputProps = {{
                      endAdornment: <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                    }}
                    type={showPassword ? 'text' : 'password'}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                  {t('changePassword.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </Paper>
      </FormProvider>
    </>
  );
}
